import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[eidosTargetValue]',
    standalone: false
})
export class EidosTargetValueDirective {
  /**
   * target value
   *
   * @type {string}
   * @memberof EidosTargetValueDirective
   */
  @Input() eidosTargetValue:any;

  constructor(
    private _elementRef: ElementRef
    , private _renderer: Renderer2) {

  }
  ngOnInit(): void {
    if(this._elementRef.nativeElement) this._renderer.setAttribute(this._elementRef.nativeElement, 'data-eidos-target-value', this.eidosTargetValue);
  }
}
